const pageNameKey = "usersList";

export const usersListEn = {
  [pageNameKey]: {
    givenNameLabel: "First Name",
    familyNameLabel: "Last Name",
    usernameLabel: "Username",
    emailLabel: "Email",
    statusLabel: "Status",
    rolesLabel: "Roles",
    createdAtLabel: "Created at",
    updatedAtLabel: "Last Modified at",
    statusTextActive: "Active",
    statusTextInactive: "Inactive",
    statusTextInitial: "Initial",
    noUsersFoundMessage: "No users could be found.",
    rolesDescriptionPopoverAltText: "Hover for roles description",
    loginNameLabel: "Login Name",
  },
};

export const usersListPtBr = {
  [pageNameKey]: {
    givenNameLabel: "Nome",
    familyNameLabel: "Sobrenome",
    usernameLabel: "Nome de usuário",
    emailLabel: "E-mail",
    statusLabel: "Status",
    rolesLabel: "Funções",
    createdAtLabel: "Criado em",
    updatedAtLabel: "Última modificação às",
    statusTextActive: "Ativo",
    statusTextInactive: "Inativo",
    statusTextInitial: "Inicial",
    noUsersFoundMessage: "Nenhum usuário foi encontrado.",
    rolesDescriptionPopoverAltText:
      "Passe o mouse para ver a descrição das funções",
    loginNameLabel: "Nome de Login",
  },
};

export const usersListDe = {
  [pageNameKey]: {
    givenNameLabel: "Vorname",
    familyNameLabel: "Nachname",
    usernameLabel: "Benutzername",
    emailLabel: "E-Mail",
    statusLabel: "Status",
    rolesLabel: "Rollen",
    createdAtLabel: "Erstellt am",
    updatedAtLabel: "Zuletzt geändert am",
    statusTextActive: "Aktiv",
    statusTextInactive: "Inaktiv",
    statusTextInitial: "Initial",
    noUsersFoundMessage: "Es konnten keine Benutzer gefunden werden.",
    rolesDescriptionPopoverAltText: "Für Rollendetails hovern",
    loginNameLabel: "Anmeldename",
  },
};

export const usersListZhHans = {
  [pageNameKey]: {
    givenNameLabel: "名字",
    familyNameLabel: "姓氏",
    usernameLabel: "用户名",
    emailLabel: "电子邮件",
    statusLabel: "状态",
    rolesLabel: "角色",
    createdAtLabel: "创建于",
    updatedAtLabel: "最后修改",
    statusTextActive: "活跃的",
    statusTextInactive: "不活跃的",
    statusTextInitial: "初始的",
    noUsersFoundMessage: "未找到用户。",
    rolesDescriptionPopoverAltText: "将鼠标悬停以查看角色描述",
    loginNameLabel: "登录名",
  },
};

export const usersListIt = {
  [pageNameKey]: {
    givenNameLabel: "Nome",
    familyNameLabel: "Cognome",
    usernameLabel: "Nome utente",
    emailLabel: "Email",
    statusLabel: "Stato",
    rolesLabel: "Ruoli",
    createdAtLabel: "Creato il",
    updatedAtLabel: "Ultimo aggiornamento il",
    statusTextActive: "Attivo",
    statusTextInactive: "Inattivo",
    statusTextInitial: "Iniziale",
    noUsersFoundMessage: "Nessun utente è stato trovato.",
    rolesDescriptionPopoverAltText:
      "Posiziona il cursore qui per la descrizione dei ruoli",
    loginNameLabel: "Nome login",
  },
};

export const usersListEs = {
  [pageNameKey]: {
    givenNameLabel: "Nombre",
    familyNameLabel: "Apellido",
    usernameLabel: "Nombre de usuario",
    emailLabel: "Correo electrónico",
    statusLabel: "Estado",
    rolesLabel: "Roles",
    createdAtLabel: "Creado el",
    updatedAtLabel: "Última modificación a las",
    statusTextActive: "Activo",
    statusTextInactive: "Inactivo",
    statusTextInitial: "Inicial",
    noUsersFoundMessage: "No se pudo encontrar ningún usuario.",
    rolesDescriptionPopoverAltText:
      "Pasa el cursor para ver la descripción de los roles",
    loginNameLabel: "Nombre de inicio de sesión",
  },
};

export const usersListNl = {
  [pageNameKey]: {
    createdAtLabel: "Aangemaakt op",
    emailLabel: "E-mail",
    familyNameLabel: "Achternaam",
    givenNameLabel: "Voornaam",
    loginNameLabel: "Login Name",
    noUsersFoundMessage: "Er zijn geen gebruikers gevonden.",
    rolesDescriptionPopoverAltText: "Beweeg de muis over een rol voor details",
    rolesLabel: "Rollen",
    statusLabel: "Status",
    statusTextActive: "Actief",
    statusTextInactive: "Inactief",
    statusTextInitial: "Initieel",
    updatedAtLabel: "Laatst gewijzigd op",
    usernameLabel: "Gebruikersnaam",
  },
};

export const usersListTr = {
  [pageNameKey]: {
    createdAtLabel: "Oluşturulma tarihi:",
    emailLabel: "E-posta",
    familyNameLabel: "Soy isim",
    givenNameLabel: "İlk adı",
    loginNameLabel: "Giriş Adı",
    noUsersFoundMessage: "Hiçbir kullanıcı bulunamadı.",
    rolesDescriptionPopoverAltText:
      "Rollerin açıklaması için fareyle üzerine gelin",
    rolesLabel: "Roller",
    statusLabel: "Durum",
    statusTextActive: "Aktif",
    statusTextInactive: "Etkin değil",
    statusTextInitial: "İlk",
    updatedAtLabel: "Son Değiştirilme tarihi:",
    usernameLabel: "Kullanıcı adı",
  },
};
